import { defineComponent as a, openBlock as l, createBlock as t, unref as u, withCtx as i, createTextVNode as r, toDisplayString as m, createVNode as f } from "vue";
import { RevTooltip as s } from "@ds/components/Tooltip";
import c from "./components/CouponBody.vue2.js";
const C = /* @__PURE__ */ a({
  name: "RevCoupon",
  __name: "Coupon",
  props: {
    label: {},
    icon: {},
    tooltipText: {}
  },
  setup(o) {
    return (b, k) => o.tooltipText ? (l(), t(u(s), {
      key: 0,
      alignment: "left",
      class: "inline-block"
    }, {
      trigger: i(({ show: e, hide: n }) => [
        f(c, {
          icon: o.icon,
          label: o.label,
          "with-info": "",
          onClick: e,
          onFocusin: e,
          onFocusout: n,
          onMouseleave: n,
          onMouseover: e
        }, null, 8, ["icon", "label", "onClick", "onFocusin", "onFocusout", "onMouseleave", "onMouseover"])
      ]),
      default: i(() => [
        r(" " + m(o.tooltipText), 1)
      ]),
      _: 1
    })) : (l(), t(c, {
      key: 1,
      icon: o.icon,
      label: o.label
    }, null, 8, ["icon", "label"]));
  }
});
export {
  C as default
};
